import * as types from "../constants";

const initialState = {
  isLoading: true,
  error: null,
  items: 0,
};

export default function DisseminationRuleCheckLockeddReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case types.GET_DISSEMINATION_RULE_CHECK_LOCKED_INIT:
      return { ...state, error: null, isLoading: false };

    case types.GET_DISSEMINATION_RULE_CHECK_LOCKED_SUCCESS:
      return { ...state, isLoading: false, items: action.data.data };

    case types.GET_DISSEMINATION_RULE_CHECK_LOCKED_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.notification.system_message,
      };

    default:
      return state;
  }
}
